module.exports = __webpack_public_path__ + "static/media/guide_img2_3.20c07aff.png";